export const PATIENT_CURVES_EXPORT_CONST = [
  {
    font: { bold: true, color: '#FFFFFF', fontName: 'Arial', size: 11 },
    id: 'header',
    interior: { color: '#094673', pattern: 'Solid', patternColor: '#094673' },
  },
  {
    font: { color: '#D73C37' },
    id: 'text-aux-error',
  },
  {
    font: { color: '#437F7F' },
    id: 'text-aux-green',
  },
  {
    alignment: { horizontal: 'Right' },
    font: { fontName: 'Arial', size: 11 },
    id: 'cellPercent',
    numberFormat: { format: '0.00;-0.00;—;—' },
  },
  {
    font: { bold: true, color: '#FFFFFF', fontName: 'Arial', size: 11 },
    id: 'first_row',
    interior: { color: '#999999', pattern: 'Solid', patternColor: '#999999' },
  },
  {
    font: { bold: true, color: '#000000', fontName: 'Arial', size: 11 },
    id: 'total_row_header',
    interior: { color: '#D9D9D9', pattern: 'Solid', patternColor: '#D9D9D9' },
  },
  {
    dataType: 'Number',
    font: { bold: true, color: '#000000', fontName: 'Arial', size: 11 },
    id: 'total_row_extended_decimal',
    interior: { color: '#D9D9D9', pattern: 'Solid', patternColor: '#D9D9D9' },
    numberFormat: { format: '#,##0.00#######' },
  },
  {
    alignment: {
      horizontal: 'Right',
    },
    dataType: 'String',
    font: { bold: true, color: '#000000', fontName: 'Arial', size: 11 },
    id: 'total_row_percent',
    interior: { color: '#D9D9D9', pattern: 'Solid', patternColor: '#D9D9D9' },
  },
];
